<template>
  <div>
    <div v-if="context.state === API_STATES.error">
      <strong>Oops, da ist wohl etwas schief gelaufen.</strong>
    </div>

    <div v-else-if="showPlaceholder" class="teaser-container">
      <bpb-teaser-placeholder
        v-for="index in context.requestParams.limit || 9"
        :key="`teaser-placeholder-${index}`"
      ></bpb-teaser-placeholder>
    </div>

    <bpb-teaser-renderer
      v-else-if="hasResults"
      :teaser-list="teaserList"
    ></bpb-teaser-renderer>

    <div v-else><slot /></div>
  </div>
</template>

<script>
import { API_STATES } from './bpb-api-endpoint.vue';

export default {
  inject: {
    context: {
      default() {
        return {};
        // fail silently, if not inside form, and use local value
      },
    },
  },
  provide() {
    return {
      reducedTeaser: this.reducedTeaser,
      teaserHeadingLevel: this.teaserHeadingLevel,
    };
  },
  props: {
    reducedTeaser: {
      type: Boolean,
      default: false,
    },
    teaserHeadingLevel: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      API_STATES,
    };
  },
  computed: {
    showPlaceholder() {
      return (
        this.context.responseHistory.length === 0 &&
        this.context.state === API_STATES.fetching
      );
    },
    teaserList() {
      return this.context?.responseHistory.reduce((teaserList, response) => {
        if (response.teaser) teaserList.push(...response.teaser);
        return teaserList;
      }, []);
    },
    resultLength() {
      return this.teaserList?.length || 0;
    },
    hasResults() {
      return this.resultLength > 0 || this.context?.state !== 'success';
    },
  },
};
</script>
